import axios from "axios";

export const newApiBase = process.env.REACT_APP_NEW_API_BASE_URL;
export const liveApi = process.env.REACT_APP_API_BASE_URL;
export const stagingApi = process.env.REACT_APP_API_STAGING_BASE_URL;
export const preprodApi = process.env.REACT_APP_API_PREPROD_BASE_URL;

const currentUrl = window.location.href;

export const API_BASE_URL =
  currentUrl.includes("staging") || currentUrl.includes("localhost")
    ? stagingApi
    : currentUrl.includes("pregames")
      ? preprodApi
      : liveApi;

export const NEW_API_BASE_URL = newApiBase;
export const API_VERSION = "/v1";

export const SOCKET_URL =
  currentUrl.includes("staging") || currentUrl.includes("localhost")
    ? stagingApi
    : currentUrl.includes("pregames")
      ? "https://preprod-socket.bitanicagames.com/"
      : "https://socket.bitanicagames.com/";

// ─── Axios Instances ──────────────────────────────────────────────────────────

const axiosApi = axios.create({ baseURL: API_BASE_URL + "/api" + API_VERSION });
axiosApi.defaults.withCredentials = true;
axiosApi.defaults.withXSRFToken = true;

const newAxiosApi = axios.create({
  baseURL: NEW_API_BASE_URL + "/api" + API_VERSION,
});
newAxiosApi.defaults.withCredentials = true;
newAxiosApi.defaults.withXSRFToken = true;

[axiosApi, newAxiosApi].forEach((instance) => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error),
  );
});

// ─── Token/Cookie Helpers (old API only) ─────────────────────────────────────

export const updateCSRFToken = (token) => {
  axiosApi.defaults.headers.common["csrf-token"] = token;
};

export const updateCookieInHeader = (cookie) => {
  axiosApi.defaults.headers.common["cookie"] = cookie;
};
export const updateToken = (token) => {
  //  axiosApi.defaults.headers.common["Authorization"] = "Bearer " + token
};

// ─── Core Request Function ────────────────────────────────────────────────────

const checkStatusCode = (code, err) => {
  if (code && [403, 501, 502, 503].includes(code)) {
    throw new Error(err.response.data.message);
  } else {
    throw new Error(err.message);
  }
};

async function request(instance, method, url, data, config = {}) {
  if (!config?.nonce || !config?.signature) {
    throw new Error("Signature missing!");
  }

  const headers = {
    ...(config?.headers || {}),
    "x-nonce": config.nonce,
    "x-signature": config.signature,
  };

  try {
    const response = await instance[method](
      url,
      ...(data !== undefined ? [data] : []),
      {
        ...config,
        withCredentials: true,
        withXSRFToken: true,
        headers,
      },
    );

    if (response?.data?.status === "success") return response.data;
    throw new Error(response?.data?.message || "Something went wrong!");
  } catch (e) {
    checkStatusCode(!e.response ? null : e.response.status, e);
  }
}

// ─── Old API (hits API_BASE_URL) ──────────────────────────────────────────────

export const get = (url, config) =>
  request(axiosApi, "get", url, undefined, config);
export const post = (url, data, config) =>
  request(axiosApi, "post", url, data, config);
export const put = (url, data, config) =>
  request(axiosApi, "put", url, data, config);
export const del = (url, config) =>
  request(axiosApi, "delete", url, undefined, config);

// ─── New API (hits NEW_API_BASE_URL) ──────────────────────────────────────────

export const newGet = (url, config) =>
  request(newAxiosApi, "get", url, undefined, config);
export const newPost = (url, data, config) =>
  request(newAxiosApi, "post", url, data, config);
export const newPut = (url, data, config) =>
  request(newAxiosApi, "put", url, data, config);
export const newDel = (url, config) =>
  request(newAxiosApi, "delete", url, undefined, config);
